'use client'

import { ReactElement, useRef, useState } from 'react'
import { tss } from 'tss-react/mui'
import useIsomorphicLayoutEffect from '../useLayoutEffect'
import { MAX_SCROLLBAR_SIZE, ScrollerProps } from './common'

const { useLayoutEffect } = useIsomorphicLayoutEffect

const useStyles = tss.create(({ theme }) => ({
    basicRoot: {
        position: 'relative',
        overflowY: 'hidden',
    },
    basicInner: {
        display: 'flex',
        alignItems: 'flex-start',
        flexwrap: 'nowrap',
        overflowX: 'auto',
        paddingRight: theme.spacing(2),
    },
}))

export default function BasicScroller({ children }: ScrollerProps): ReactElement {
    const [contentHeight, setContentHeight] = useState(0)
    const containerRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const { classes } = useStyles()

    useLayoutEffect(() => {
        if (!contentRef.current) {
            return
        }

        setContentHeight(contentRef.current.offsetHeight)
    }, [])

    return (
        <div className={classes.basicRoot} style={{ height: contentHeight }}>
            <div
                className={classes.basicInner}
                style={{ height: contentHeight + MAX_SCROLLBAR_SIZE }}
                ref={containerRef}
            >
                <div ref={contentRef}>{children}</div>
            </div>
        </div>
    )
}
